import ActionDialog from "@dashboard/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import ControlledCheckbox from "@dashboard/components/ControlledCheckbox";
import { OrderErrorFragment } from "@dashboard/graphql";
import useModalDialogErrors from "@dashboard/hooks/useModalDialogErrors";
import getOrderErrorMessage from "@dashboard/utils/errors/order";
import { Box, Text } from "@saleor/macaw-ui-next";
import { FormattedMessage, useIntl } from "react-intl";

interface OrderDraftFinalizeDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  errors: OrderErrorFragment[];
  open: boolean;
  orderNumber: string;
  notifyCustomer: boolean;
  onClose: () => void;
  onConfirm: () => void;
  handleNotifyCustomer: (checked: boolean) => void;
}

const OrderDraftFinalizeDialog = ({
  confirmButtonState,
  errors: apiErrors,
  open,
  orderNumber,
  notifyCustomer,
  onClose,
  onConfirm,
  handleNotifyCustomer,
}: OrderDraftFinalizeDialogProps) => {
  const intl = useIntl();
  const errors = useModalDialogErrors(apiErrors, open);

  return (
    <ActionDialog
      confirmButtonState={confirmButtonState}
      open={open}
      title={intl.formatMessage({
        id: "UsTHF4",
        defaultMessage: "Finalize Draft Order",
        description: "dialog header",
      })}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmButtonLabel={intl.formatMessage({
        id: "4Z14xW",
        defaultMessage: "Finalize",
        description: "button",
      })}
    >
      <Box display="grid" gap={4}>
        <FormattedMessage
          id="Q2N/N1"
          defaultMessage="You're going to finalize draft order #{orderNumber}."
          values={{ orderNumber }}
        />
        <ControlledCheckbox
          data-test-id="notify-customer"
          name="notifyCustomer"
          label={intl.formatMessage({
            id: "yLEZpm",
            defaultMessage: "Send order confirmation to the customer",
            description: "finalize draft order, notify customer checkbox",
          })}
          checked={notifyCustomer}
          onChange={event => handleNotifyCustomer(event.target.value)}
        />
        {errors.length > 0 && (
          <Box display="grid" gap={1}>
            {errors.map((err, index) => (
              <Text color="critical1" key={index}>
                {getOrderErrorMessage(err, intl)}
              </Text>
            ))}
          </Box>
        )}
      </Box>
    </ActionDialog>
  );
};

OrderDraftFinalizeDialog.displayName = "OrderDraftFinalizeDialog";
export default OrderDraftFinalizeDialog;
